export default __webpack_public_path__ + "static/media/tab_3.65458111.svg";